/* WESN Story page — optional motion layer, click-to-play YouTube (one player at a time), chapter index, ticker, hero film.
   The page is complete in Liquid/CSS; everything here is an enhancement and every section initialises independently. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)');
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var io = null, idxIo = null, avoidIo = null, active = null, cleanups = [];

  function motionAllowed() { return !rm.matches && !doc.querySelector('[data-st-motion="off"]'); }
  function revealAll() { doc.querySelectorAll('.story [data-st-reveal],.story [data-st-group],.story .st-timeline').forEach(function (el) { el.classList.add('is-in'); }); }
  function setMotion() { var on = motionAllowed(); root.classList.toggle('st-motion', on); if (!on) revealAll(); }

  /* ---------- entry reveals (IntersectionObserver; static fallback) ---------- */
  function observe(scope) {
    var els = scope.querySelectorAll('[data-st-reveal]:not(.is-in),[data-st-group]:not(.is-in),.st-timeline:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || !motionAllowed()) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    if (!io) io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    els.forEach(function (el) {
      if (el.hasAttribute('data-st-group')) [].forEach.call(el.children, function (c, j) { c.style.setProperty('--st-i', Math.min(j, 8)); });
      io.observe(el);
    });
  }

  /* ---------- YouTube: create the player only when pressed; one active player; close restores the poster ---------- */
  function ytStop(el) {
    var f = el.querySelector('iframe'); if (f) f.remove();
    var x = el.querySelector('.st-yt__close'); if (x) x.remove();
    el.classList.remove('is-playing');
    if (active === el) active = null;
  }
  function ytPlay(el) {
    if (el.classList.contains('is-playing')) return;
    var id = el.getAttribute('data-yt'); if (!id) return;
    if (active && active !== el) ytStop(active);
    var f = doc.createElement('iframe');
    f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    f.title = el.getAttribute('data-yt-title') || 'YouTube video';
    f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    f.setAttribute('allowfullscreen', '');
    var x = doc.createElement('button'); x.type = 'button'; x.className = 'st-yt__close'; x.setAttribute('aria-label', 'Close video'); x.innerHTML = '&times;';
    x.addEventListener('click', function (ev) { ev.stopPropagation(); ytStop(el); var b = el.querySelector('.st-yt__btn'); if (b) b.focus(); });
    el.classList.add('is-playing'); el.appendChild(f); el.appendChild(x); active = el; x.focus();
  }
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('.st-yt__btn'); if (!b) return;
    var el = b.closest('[data-yt]'); if (!el) return;
    e.preventDefault(); ytPlay(el);
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && active) { var el = active; ytStop(el); var b = el.querySelector('.st-yt__btn'); if (b) b.focus(); }
  });
  function fixThumbs(scope) {
    scope.querySelectorAll('img[data-yt-thumb]').forEach(function (img) {
      function check() { if (img.naturalWidth && img.naturalWidth < 200) { img.src = 'https://i.ytimg.com/vi/' + img.getAttribute('data-yt-thumb') + '/hqdefault.jpg'; img.removeAttribute('data-yt-thumb'); } }
      if (img.complete) check(); else img.addEventListener('load', check, { once: true });
    });
  }

  /* ---------- chapter index (desktop, rebuilt whenever sections change) ---------- */
  function buildIndex() {
    var old = doc.getElementById('st-index'); if (old) old.remove();
    if (idxIo) { idxIo.disconnect(); idxIo = null; }
    if (avoidIo) { avoidIo.disconnect(); avoidIo = null; }
    var chapters = [].slice.call(doc.querySelectorAll('[data-st-chapter]'));
    if (chapters.length < 2 || window.innerWidth < 1280 || !('IntersectionObserver' in window)) return;
    var nav = doc.createElement('nav'); nav.id = 'st-index'; nav.className = 'st-index'; nav.setAttribute('aria-label', 'Chapters');
    var ol = doc.createElement('ol');
    chapters.forEach(function (sec) {
      var li = doc.createElement('li'), a = doc.createElement('a'), i = doc.createElement('i'), s = doc.createElement('span'), em = doc.createElement('em');
      a.href = '#' + sec.id; i.setAttribute('aria-hidden', 'true');
      s.textContent = sec.getAttribute('data-st-chapter'); em.textContent = sec.getAttribute('data-st-chapter-label') || '';
      a.setAttribute('aria-label', (sec.getAttribute('data-st-chapter') + ' ' + em.textContent).trim());
      a.appendChild(i); a.appendChild(s); if (em.textContent) a.appendChild(em); li.appendChild(a); ol.appendChild(li);
    });
    nav.appendChild(ol); doc.body.appendChild(nav);
    idxIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        nav.querySelectorAll('a[aria-current]').forEach(function (a) { a.removeAttribute('aria-current'); });
        var a = nav.querySelector('a[href="#' + en.target.id + '"]'); if (a) a.setAttribute('aria-current', 'true');
      });
    }, { rootMargin: '-40% 0px -50% 0px', threshold: 0 });
    chapters.forEach(function (c) { idxIo.observe(c); });
    /* keep the index off full-bleed media: hide it while the hero or a left-side photo crosses its band */
    var avoid = doc.querySelectorAll('[data-st-avoid]'), over = 0;
    if (avoid.length) {
      avoidIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { over += en.isIntersecting ? 1 : -1; });
        over = Math.max(0, over); nav.classList.toggle('is-hidden', over > 0);
      }, { rootMargin: '-38% 0px -38% 0px', threshold: 0 });
      avoid.forEach(function (el) { avoidIo.observe(el); });
    }
  }
  var idxTimer = null;
  function scheduleIndex() { clearTimeout(idxTimer); idxTimer = setTimeout(buildIndex, 120); }

  /* ---------- horizontal rails (episode strip, poster carousel): arrows, end states, optional counter + arrow keys ---------- */
  function railInit(rail, prev, next, opts) {
    opts = opts || {};
    if (!rail) return;
    function unit() { var item = opts.item ? rail.querySelector(opts.item) : null; return item ? item.getBoundingClientRect().width + (opts.gap || 0) : rail.clientWidth * 0.7; }
    function step(dir) { rail.scrollBy({ left: dir * unit(), behavior: motionAllowed() ? 'smooth' : 'auto' }); }
    function update() {
      if (prev) prev.disabled = rail.scrollLeft <= 4;
      if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
      if (opts.count && opts.item) { var n = rail.querySelectorAll(opts.item).length, u = unit() || 1, i = Math.min(n, Math.max(1, Math.round(rail.scrollLeft / u) + 1)); opts.count.textContent = i + ' / ' + n; }
    }
    function onKey(e) { if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); } else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); } }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    rail.addEventListener('scroll', update, { passive: true });
    if (opts.keys) rail.addEventListener('keydown', onKey);
    /* end states depend on layout, which can still change after init (stylesheet applied late, fonts, images, viewport) */
    var ro = null;
    if ('ResizeObserver' in window) { ro = new ResizeObserver(update); ro.observe(rail); var first = opts.item ? rail.querySelector(opts.item) : null; if (first) ro.observe(first); }
    window.addEventListener('load', update); window.addEventListener('resize', update, { passive: true });
    update(); requestAnimationFrame(update);
    /* optional auto-advance (a "moving" rail): wraps to the start, pauses while hovered / focused / touched / off screen,
       waits 6 s after any interaction, and never runs for reduced-motion visitors */
    var timer = null, vis = null, inView = true, hover = false, holdUntil = 0, host = opts.host || rail;
    function tick() {
      if (!motionAllowed() || !inView || hover || Date.now() < holdUntil || doc.hidden) return;
      if (rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4) rail.scrollTo({ left: 0, behavior: 'smooth' }); else step(1);
    }
    function hold() { holdUntil = Date.now() + 6000; }
    if (opts.autoplay > 0) {
      host.addEventListener('mouseenter', function () { hover = true; }); host.addEventListener('mouseleave', function () { hover = false; });
      host.addEventListener('focusin', function () { hover = true; }); host.addEventListener('focusout', function () { hover = false; });
      host.addEventListener('touchstart', hold, { passive: true }); host.addEventListener('pointerdown', hold); host.addEventListener('keydown', hold);
      if ('IntersectionObserver' in window) { vis = new IntersectionObserver(function (e) { inView = e[0].isIntersecting; }, { threshold: 0.3 }); vis.observe(rail); }
      timer = setInterval(tick, opts.autoplay);
    }
    return function () { rail.removeEventListener('scroll', update); rail.removeEventListener('keydown', onKey); window.removeEventListener('load', update); window.removeEventListener('resize', update); if (ro) ro.disconnect(); if (timer) clearInterval(timer); if (vis) vis.disconnect(); };
  }

  /* ---------- per-section behaviour ---------- */
  var inits = {
    poster: function (sec) {
      var c = sec.querySelector('[data-st-carousel]'); if (!c) return;
      return railInit(c.querySelector('[data-st-rail]'), c.querySelector('[data-st-rail-prev]'), c.querySelector('[data-st-rail-next]'), { item: '.st-carousel__item', gap: 0, count: c.querySelector('[data-st-rail-count]'), keys: true, host: c, autoplay: parseInt(c.getAttribute('data-st-autoplay') || '0', 10) });
    },
    hero: function (sec) {
      var film = sec.querySelector('[data-st-film]'); if (!film) return;
      var small = window.matchMedia('(max-width: 1023px)').matches;
      var src = (small && film.getAttribute('data-src-sm')) || film.getAttribute('data-src'), wrap = sec.querySelector('.st-hero');
      if (!src) return;
      var auto = motionAllowed() && !saveData, vis = null, inView = false;
      function attach() { if (film.querySelector('source')) return; var s = doc.createElement('source'); s.src = src; s.type = 'video/mp4'; film.appendChild(s); film.load(); }
      function state(on) { if (wrap) wrap.classList.toggle('st-hero--playing', on); }
      function play() { attach(); var p = film.play(); if (p && p.catch) p.catch(function () { state(false); }); }
      function seen() { var r = film.getBoundingClientRect(); return r.bottom > 0 && r.top < (window.innerHeight || root.clientHeight); }
      function onVisible() { if (!doc.hidden && film.paused && (inView || seen())) play(); }
      film.addEventListener('playing', function () { state(true); });
      film.addEventListener('pause', function () { state(false); });
      if (auto) {
        if ('IntersectionObserver' in window) {
          vis = new IntersectionObserver(function (e) { inView = e[0].isIntersecting; if (inView) play(); else if (!film.paused) film.pause(); }, { threshold: 0.05 });
          vis.observe(film);
        }
        /* no on-page control any more: start it if the observer is late or throttled, and resume when a hidden tab is shown */
        setTimeout(onVisible, 600);
        doc.addEventListener('visibilitychange', onVisible);
      }
      var cue = sec.querySelector('[data-st-cue]');
      function onCue(ev) { var next = sec.nextElementSibling; if (cue.getAttribute('href') === '#story-next' && next) { ev.preventDefault(); next.scrollIntoView({ behavior: motionAllowed() ? 'smooth' : 'auto', block: 'start' }); } }
      if (cue) cue.addEventListener('click', onCue);
      return function () { if (vis) vis.disconnect(); doc.removeEventListener('visibilitychange', onVisible); film.pause(); };
    },
    wall: function (sec) {
      var m = sec.querySelector('[data-st-marquee]'); if (!m) return;
      var vis = null;
      if (!motionAllowed()) return;
      if ('IntersectionObserver' in window) { vis = new IntersectionObserver(function (e) { m.classList.toggle('is-on', e[0].isIntersecting); }, { threshold: 0 }); vis.observe(m); }
      else m.classList.add('is-on');
      return function () { if (vis) vis.disconnect(); };
    },
    shorts: function (sec) {
      var rail = sec.querySelector('.st-shorts'), prev = sec.querySelector('[data-st-rail-prev]'), next = sec.querySelector('[data-st-rail-next]');
      if (!rail || !prev || !next) return;
      return railInit(rail, prev, next, { item: '.st-shorts__item', gap: 8 });
    }
  };

  function initSection(sec) {
    cleanupSection(sec);
    var body = sec.querySelector('[data-st-section]'); if (!body) return;
    var fns = [];
    try { observe(sec); fixThumbs(sec); var fn = inits[body.getAttribute('data-st-section')]; if (fn) { var c = fn(sec); if (typeof c === 'function') fns.push(c); } }
    catch (err) { if (window.console) console.warn('Story section skipped:', err); }
    cleanups.push({ sec: sec, fns: fns });
  }
  function cleanupSection(sec) {
    cleanups = cleanups.filter(function (c) { if (c.sec !== sec) return true; c.fns.forEach(function (f) { try { f(); } catch (e) {} }); return false; });
    if (active && sec.contains(active)) ytStop(active);
  }
  function initAll() {
    setMotion();
    doc.querySelectorAll('.shopify-section').forEach(function (sec) { if (sec.querySelector('[data-st-section]')) initSection(sec); });
    scheduleIndex();
  }

  if (rm.addEventListener) rm.addEventListener('change', setMotion);
  doc.addEventListener('shopify:section:load', function (e) { setMotion(); initSection(e.target); scheduleIndex(); });
  doc.addEventListener('shopify:section:unload', function (e) { cleanupSection(e.target); scheduleIndex(); });
  doc.addEventListener('shopify:section:reorder', scheduleIndex);
  doc.addEventListener('shopify:section:select', function (e) { if (e.target) e.target.querySelectorAll('[data-st-reveal],[data-st-group],.st-timeline').forEach(function (el) { el.classList.add('is-in'); }); });
  var rt = null; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(scheduleIndex, 200); }, { passive: true });
  /* safety net: if anything above throws before the observers run, nothing stays hidden */
  setTimeout(function () { if (root.classList.contains('st-motion')) doc.querySelectorAll('.story [data-st-reveal]:not(.is-in),.story [data-st-group]:not(.is-in)').forEach(function (el) { if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in'); }); }, 3000);

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', initAll); else initAll();
})();
